import axios from 'axios'
import { Query } from '../../helpers/query'
import {
    SERVER
} from '../../api'

export const commentFind = (query = { id_discussion_comment, id_user }, cb) => async dispatch => {
    try {
        const { data } = await axios({
            method: 'GET',
            url: `${SERVER}/discussions/find_comment?token=${process.env.REACT_APP_API_TOKEN}&${Query(query)}`,
        })
        if (data.status) {
            cb(true, data.result)
        }
    } catch (error) {
        if (error) {
            if (error.response) {
                if (error.response.data) {
                    let { status, message } = error.response.data
                    if (message === 'Not Found' && status === false) {
                        cb(true, [])
                    }
                }
            }
        }
    }
}

export const commentList = (query = { id_discussion, id_user, limit, offset, order_by, group_by }, cb) => async dispatch => {
    try {
        const { data } = await axios({
            method: 'GET',
            url: `${SERVER}/discussions/list_comment?token=${process.env.REACT_APP_API_TOKEN}&${Query(query)}`,
        })
        if (data.status) {
            cb(true, data.result)
        }
    } catch (error) {
        if (error) {
            if (error.response) {
                if (error.response.data) {
                    let { status, message } = error.response.data
                    if (message === 'Not Found' && status === false) {
                        cb(true, [])
                    }
                }
            }
        }
    }
}

export const commentCreate = (sendData = { id_discussion, id_user, comment }, cb) => async dispatch => {
    try {
        const { data } = await axios({
            method: 'POST',
            url: `${SERVER}/discussions/create_comment?token=${process.env.REACT_APP_API_TOKEN}`,
            data: sendData
        })
        if (data.status) {
            cb(true, data.result)
        }
    } catch (error) {
        if (error) {
            if (error.response) {
                if (error.response.data) {
                    let { status, message } = error.response.data
                    if (message === 'Not Found' && status === false) {
                        cb(true, [])
                    }
                }
            }
        }
    }
}

export const commentUpdate = (sendData = { id_discussion_comment, id_discussion, id_idea, id_user, comment, is_delete }, cb) => async dispatch => {
    try {
        const { data } = await axios({
            method: 'PUT',
            url: `${SERVER}/discussions/update?token=${process.env.REACT_APP_API_TOKEN}`,
            data: sendData
        })
        if (data.status) {
            cb(true, data.result)
        }
    } catch (error) {
        if (error) {
            if (error.response) {
                if (error.response.data) {
                    let { status, message } = error.response.data
                    if (message === 'Not Found' && status === false) {
                        cb(true, [])
                    }
                }
            }
        }
    }
}